import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    lng: "en",
    debug: true,
    ReturnObjects: true,
    resources: {
      en: {
        translation: {
          timingIs: "Hours:",
          serviceCryoMassage: "Cryo-Massage",
          serviceCryoMassageType:
            "Application of cold therapy to reduce pain and inflammation.",
          type: "Massage",
          typeDesc:
            "Therapeutic touch to relax, relieve tension, and promote well-being.",
          serviceMonthlyMembership: "Monthly membership",
          serviceMonthlymembershipType:
            "The monthly membership policy allows for 8 uses per month, with no carryover for unused services.",
          serviceSignaturefacial: "Signature facial",
          serviceSignatureFacialType:
            "A luxurious facial designed to cleanse, exfoliate, and revitalize your skin.",
          servicecryoSkinHealth: "Cryo-Skin health (Acne, Eczema, Psoriasis)",
          serviceCryofacial: "Cryo facial",
          serviceCryofacialType:
            "targeting wrinkles, fine lines, blemishes, and scars.",
          serviceCryoslimming: "Cryo slimming",
          serviceCryoslimmingType:
            "permanently destroying underlying fat cells (apoptosis)",
          serviceTargetedTherapy: "Targeted Cryotherapy",
          serviceTargetedTherapyType:
            "Targets specific areas, perfect for athletes, fitness enthusiasts",
          serviceEyelashesExtension: "Eyelashes Extension",
          serviceEyelashesExtensionType: " Eyelashes extension services",
          localizedCryotherapy: "Localized Cryotherapy",
          cryoMassageTitle: "Cryo Facial",
          cryotherapyFacial: "Cryo Massage",
          cryoSlimming: "Cryo Slimming",
          faceMassage: "Face Massage",
          therapyAddictionalMassage: "Therapeutic Traditional Massage",
          coupleMassage: "Couple Massage",

          massages: {
            meridian60: {
              title: "Meridian Massage - 60 Minutes",
              description:
                "Meridian massage is a therapeutic bodywork practice rooted in Traditional Chinese Medicine (TCM) that stimulates the body's energy pathways, known as meridians or jing-luo, to restore balance and promote healing.",
              cost: "$130.00",
            },
            swedish60: {
              title: "Swedish Massage - 60 Minutes",
              description:
                "Gentle, flowing strokes for relaxation, tension relief, and overall well-being.",
              cost: "$125.00",
            },
            swedish90: {
              title: "Swedish Massage - 90 Minutes",
              description:
                "Gentle, flowing strokes for relaxation, tension relief, and overall well-being.",
              cost: "$175.00",
            },
            // swedish120: {
            //   title: "Swedish Massage - 120 Minutes",
            //   description: "Uses massage oils to facilitate smooth, gliding strokes over the entire body.",
            //   cost: '$130.00'
            // },
            reflexology60: {
              title: "Reflexology Massage - 60 Minutes",
              description:
                "Pressure on specific points to promote relaxation and healing.",
              cost: "$125.00",
            },
            reflexology90: {
              title: "Reflexology Massage - 90 Minutes",
              description:
                "Pressure on specific points to promote relaxation and healing.",
              cost: "$175.00",
            },
            // reflexology120: {
            //   title: "Reflexology Massage - 120 Minutes",
            //   description: "Pressure on specific points to promote relaxation and healing.",
            //   cost: '$130.00',
            // },
            therapeutic60: {
              title: "Therapeutic Massage - 60 Minutes",
              description:
                "Targeted treatment to address specific health issues and promote relaxation.",
              cost: "$125.00",
            },
            therapeutic90: {
              title: "Therapeutic Massage - 90 Minutes",
              description:
                "Targeted treatment to address specific health issues and promote relaxation.",
              cost: "$175.00",
            },
            // therapeutic120: {
            //   title: "Therapeutic Massage - 120 Minutes",
            //   description: "Targeted treatment to address specific health issues and promote relaxation.",
            //   cost: '$130.00'
            // },
            sport60: {
              title: "Sport Massage - 60 Minutes",
              description:
                "Deep tissue massage to prevent injury and improve athletic performance.",
              cost: "$125.00",
            },
            sport90: {
              title: "Sport Massage - 90 Minutes",
              description:
                "Deep tissue massage to prevent injury and improve athletic performance.",
              cost: "$175.00",
            },
            // sport120: {
            //   title: "Sport Massage - 120 Minutes",
            //   description: "Deep tissue massage to prevent injury and improve athletic performance.",
            //   cost: '$130.00'
            // },
            hotStone60: {
              title: "Hot Stone Massage - 60 Minutes",
              description:
                "Heated stones used to relax muscles and promote well-being.",
              cost: "$125.00",
            },
            hotStone90: {
              title: "Hot Stone Massage - 90 Minutes",
              description:
                "Heated stones used to relax muscles and promote well-being.",
              cost: "$175.00",
            },
            // hotStone120: {
            //   title: "Hot Stone Massage - 120 Minutes",
            //   description: "Heated stones used to relax muscles and promote well-being.",
            //   cost: '$130.00'
            // },
            couple60: {
              title: "Couple Massage - 60 Minutes",
              description:
                "Simultaneous massage for two people for a bonding experience. (Notes: please book twice under the same account and select 2 different staffs at the same time!)",
              cost: "$125.00",
            },
            // couple90: {
            //   title: "Couple Massage - 90 Minutes",
            //   description: "Simultaneous massage for two people for a bonding experience. (Notes: please book twice under the same account and select 2 different staffs at the same time!)",
            //   cost: '$100.00'
            // },
            lymphaticDrainage: {
              title: "Lymphatic Drainage Massage",
              description:
                "Gentle massage technique that stimulates lymph flow to reduce swelling, support detoxification, and promote relaxation.",
              cost: "$165.00",
            },
          },

          cryoMassage: {
            cryoMassage60: {
              title: "Cryo-Massage - 60 Minutes",
              description:
                "Cryo-massage combines cryotherapy and massage to reduce inflammation, promote healing, and provide relaxation. 50 minutes of massage follows cryotherapy.",
              cost: "$125.00",
            },
            cryoMassage90: {
              title: "Cryo-Massage - 90 Minutes",
              description:
                "Cryo-massage combines cryotherapy and massage to reduce inflammation, promote healing, and provide relaxation. 80 minutes of massage follows cryotherapy.",
              cost: "$175.00",
            },
          },

          monthlyMembership: {
            monthlyMembership30: {
              title: "30 Minutes Massage for Monthly Membership",
              description:
                "Updated monthly membership policy allowing up to 8 uses per month with no carryover for unused services.",
              cost: "$200.00",
            },
            monthlyMembership40: {
              title: "40 Minutes Massage for Monthly Membership",
              description:
                "Updated monthly membership policy allowing up to 8 uses per month with no carryover for unused services.",
              cost: "$250.00",
            },
            monthlyMembership60: {
              title: "60 Minutes Massage for Monthly Membership",
              description:
                "Updated monthly membership policy allowing up to 8 uses per month with no carryover for unused services.",
              cost: "$300.00",
            },
          },
          signaturefacial: {
            refreshingFacials: {
              title: "Refreshing Treatment Facials",
              description:
                "Excellent treatment to control oil, bring balance, and delay signs of premature aging (60 minutes).",
              cost: "$142.00",
            },
            dimondFacials: {
              title: "Dimond Treatment Facials",
              description:
                "Treatment to balance skin tone, keep youthful skin radiant, and delay signs of premature aging (60 minutes).",
              cost: "$95.00",
            },
            renewingFacials: {
              title: "Renewing Treatment Facials",
              description:
                "Treatment to repair signs of aging, including fine lines and wrinkles (60 minutes).",
              cost: "$115.00",
            },
          },
          cryoSkinHealth: {
            cryoSkinHealth1: {
              title: "Cryo Skin Health (Acne, Eczema, Psoriasis) - 1 Session",
              description:
                "Cryotherapy treatment for skin conditions like acne, eczema, and psoriasis. Reduces symptoms without side effects.",
              cost: "$150.00",
            },
            cryoSkinHealth5: {
              title: "Cryo Skin Health (Acne, Eczema, Psoriasis) - 5 Sessions",
              description:
                "Cryotherapy treatment for skin conditions. Significant symptom reduction over five sessions.",
              cost: "$499.00",
            },
          },
          cryoFacial: {
            cryoFacial1: {
              title: "Cryo Facial - 1 Session",
              description:
                "Non-invasive cosmetic treatment applying cold temperatures to improve skin tone and collagen production.",
              cost: "$120.00",
            },
            cryoFacial5: {
              title: "Cryo Facial - 5 Sessions",
              description:
                "Five-session non-invasive cosmetic treatment to improve skin tone, stimulate collagen, and enhance radiance.",
              cost: "$499.00",
            },
          },
          cryoslimming: {
            cryoSlimming1: {
              title: "Cryo Slimming - 1 Session",
              description:
                "Cryotherapy to permanently destroy fat cells and achieve immediate inch loss through skin tightening.",
              cost: "$259.00",
            },
            cryoSlimming3: {
              title: "Cryo Slimming - 3 Sessions",
              description:
                "Cryotherapy to destroy fat cells and achieve inch loss over three sessions.",
              cost: "$799.00",
            },
            cryoSlimming5: {
              title: "Cryo Slimming - 5 Sessions",
              description:
                "Cryotherapy to destroy fat cells and achieve inch loss over five sessions.",
              cost: "$1299.00",
            },
            cryoSlimming8: {
              title: "Cryo Slimming - 8 Sessions",
              description:
                "Cryotherapy to destroy fat cells and achieve inch loss over eight sessions.",
              price: "$1799.00",
              cost: "$1799.00",
            },
            cryoSlimming10: {
              title: "Cryo Slimming - 10 Sessions",
              description:
                "Cryotherapy to destroy fat cells and achieve inch loss over ten sessions.",
              price: "$1999",
              cost: "$1999",
            },
          },
          targetedCryotherapy: {
            cryoSlimming5: {
              title: "Targeted one small area.",
              description:
                "non-invasive cold therapy triggers the body's natural fight response to accelerate recovery and decrease inflammation through the body. this session is for the specific one area that needed the attention NOW!!",
              price: "$80.00",
              cost: "$80.00",
            },
            cryoSlimming8: {
              title: "Targeted area whole upper or lower back",
              description:
                "Unlike the Whole-Body Cryochambers, we’re able to target the specific areas to be treated. This is sensational for athletes, our proud service members, first responders, teachers, and many of those who sit for an extended period of time at their workplace, oftentimes causing “piriformis syndrome,” which is the muscle in your glute, which the sciatic nerve runs through, causing many back and nerve pain.",
              cost: "$120.00",
            },
            cryoSlimming10: {
              title: "Targeted area package of 5",
              description:
                "Unlike the Whole-Body Cryochambers, we’re able to target the specific areas to be treated. This is sensational for athletes, our proud service members, first responders, teachers, and many of those who sit for an extended period of time at their workplace, oftentimes causing “piriformis syndrome,” which is the muscle in your glute, which the sciatic nerve runs through, causing many back and nerve pain.",
              cost: "$499.00",
            },
          },
          eyelashesExtension: {
            eyelashService1: {
              title: "Hybrid",
              description:
                "Hybrid lash extensions offer the perfect blend of single lashes and light fans, creating a beautifully natural texture that enhances your eyes. This versatile set provides fullness and dimension while maintaining a soft, effortless look for any occasion.",
              cost: "$120",
            },
            eyelashService2: {
              title: "Volume",
              description:
                "Volume enhances your natural lashes by applying fans composed of 6 to 12 strands of lash extensions to each individual lash, creating a striking, fuller appearance. This service adds both volume and length, dramatically transforming your lashes for a more captivating look.",
              cost: "$150",
            },
            eyelashService3: {
              title: "Mega Volume",
              description:
                "Mega Volume enhances your natural lashes with unparalleled fullness and length, expertly applied by a master artist. Utilizing fans of 5 to 15 ultra-fine lash extensions on each healthy lash, this service delivers exceptional thickness, fluffiness, and dramatic length to your look.",
              cost: "$190",
            },
          },

          cryoSlimmingService: {
            heading: "Cryo slimming",
            desc: "CryoSlimming is a non-invasive treatment that eliminates stubborn fat using cold temperatures to freeze fat cells, which are gradually removed by the body. Ideal for contouring areas like the abdomen, thighs, and love handles, it helps achieve a slimmer, toned appearance without surgery or downtime.",
          },
          cryoMassageService: {
            heading: "Cryo Massage",
            desc: "Cryo massage offers benefits such as reduced inflammation, pain relief, improved circulation, enhanced recovery, and a boosted mood. It is ideal for those suffering from chronic pain over the years",
          },
          cryoFacialService: {
            heading: "Cryo facial",
            desc: "CryoFacial is a skin-rejuvenating treatment that uses cold therapy to tighten, de-puff, and refresh the face. It reduces pores, boosts collagen, smooths fine lines, and enhances skin tone, leaving your skin firm, radiant, and glowing—no downtime needed.",
          },
          targetedCryoService: {
            heading: "Targeted Cryotherapy",
            desc: "Targeted Cryotherapy uses extreme cold to reduce pain, inflammation, and discomfort in specific body areas, ideal for injuries, sore muscles, and joint pain. This localized treatment promotes faster recovery, enhances circulation, and provides quick relief without invasive procedures.",
          },
          cryoSkinHealthService: {
            heading: "Cryo-Skin Health (Acne, Eczema, Psoriasis)",
            desc: "Cryo-Skin Health uses cold therapy to treat skin conditions like acne, eczema, and psoriasis, soothing and healing irritated skin. It reduces inflammation, calms redness, and supports natural healing for clearer, healthier skin without harsh chemicals or invasive procedures.",
          },
          eyeleshService: {
            heading: "Lash Extension",
            desc: "Hybrid lash extensions offer the perfect blend of single lashes and light fans, creating a beautifully natural texture that enhances your eyes. This versatile set provides fullness and dimension while maintaining a soft, fluttery look, perfect for any occasion.",
          },
          //   signatureFacialService: {
          //     heading: "Signature Facial",
          //     desc: "The Signature Facial is a luxurious, personalized skincare treatment that deeply cleanses, exfoliates, and hydrates, leaving your skin refreshed and radiant. Tailored to target dryness, aging, or dullness, it enhances natural glow while offering a soothing, rejuvenating experience for both skin and spirit."
          // },
          coupleMassageService: {
            heading: "Couple Massage",
            desc: "Share a peaceful escape with our Couple Massage, featuring synchronized techniques that ease tension and strengthen your bond. Perfect for any occasion, this experience leaves you both refreshed and connected.",
          },

          ServiceHighlightCryoSlimming: {
            heading: "CryoSlimming",
            para: "Achieve a slimmer, toned look with CryoSlimming, a non-invasive treatment that uses cold to break down stubborn fat cells.",
            benefits: "Benefits:",
            benefitsLi1: "Non-Invasive",
            benefitsLi2: "Body Contouring",
            benefitsLi3: "Fat Reduction",
            idealFor: "Ideal For:",
            idealForText:
              "Stubborn Fat Reduction, Postpartum Mothers, Special Occasion Prep",
            duration: "30-45 minutes",
          },

          ServiceHighlightLocalizedCryo: {
            heading: "Localized Cryotherapy",
            para: "Experience targeted relief from pain and inflammation with our Localized Cryotherapy treatments. By focusing cold therapy on specific areas, we help reduce swelling, alleviate pain, and accelerate healing.",
            benefits: "Benefits:",
            benefitsLi1: "Enhanced Recovery",
            benefitsLi2: "Reduced Inflammation",
            benefitsLi3: "Pain Relief",
            idealFor: "Ideal For:",
            idealForText:
              "Athletes, Chronic Pain Sufferers, Post-Surgery Recovery",
            duration: "10-20 minutes",
          },
          CryoFacial: {
            heading: "CryoFacial",
            para: "Revitalize and rejuvenate your skin with our CryoFacial, a refreshing treatment that uses cold therapy to boost collagen production, reduce puffiness, and enhance your natural glow. This non-invasive, quick facial leaves your skin looking firm, toned, and radiant.",
            benefits: "Benefits:",
            benefitsLi1: "Boosted Collagen",
            benefitsLi2: "Reduced Puffiness",
            benefitsLi3: "Improved Skin Tone",
            idealFor: "Ideal For:",
            idealForText:
              "Those seeking a quick, non-invasive skin refresh, Anti-aging, Reducing redness and inflammation",
            duration: "40-60 minutes",
          },
          //   Cryotherapy: {
          //     heading: "Cryotherapy",
          //     para: "Experience whole-body rejuvenation with Cryotherapy, a treatment that immerses you in extreme cold to promote faster recovery, reduce inflammation, and boost energy levels. This innovative therapy helps stimulate circulation, improve mood, and relieve muscle and joint discomfort.",
          //     benefits: "Benefits:",
          //     benefitsLi1: "Faster Recovery",
          //     benefitsLi2: "Reduced Inflammation",
          //     benefitsLi3: "Boosted Energy",
          //     idealFor: "Ideal For:",
          //     idealForText: "Athletes, Individuals with Chronic Pain, Inflammation Reduction",
          //     duration: "2-3 minutes"
          // },
          TherapeuticMassage: {
            heading: "Therapeutic Massage",
            para: "Alleviate pain and tension with our Therapeutic Massage, tailored to relieve sore muscles, improve circulation, and support healing. Our skilled therapists apply targeted techniques to help restore balance, promote flexibility, and provide long-lasting relief.",
            benefits: "Benefits:",
            benefitsLi1: "Pain Relief",
            benefitsLi2: "Improved Flexibility",
            benefitsLi3: "Better Circulation",
            idealFor: "Ideal For:",
            idealForText:
              "Individuals with Chronic Pain, Stress Relief, Muscle Tension",
            duration: "30-60 minutes",
          },
          eyeleshExtension: {
            heading: "Eyelashes Extension",
            para: "Hybrid lash extensions offer the perfect blend of single lashes and light fans, creating a beautifully natural texture that enhances your eyes. This versatile set provides fullness and dimension while maintaining a soft, fluttery look, perfect for any occasion.",
            benefits: "Benefits:",
            benefitsLi1: "Natural look with volume",
            benefitsLi2: "Customizable fullness",
            benefitsLi3: "Enhances eye shape",
            idealFor: "Ideal For:",
            idealForText:
              "Individuals seeking a balance of natural and dramatic lash enhancements",
            duration: "1.5 - 2 hours",
          },

          aboutArtistrySpawellnes: "About Us",
          subsOurNewsletter: "Subscribe Now",
          contactInfo: "Contact Info",
          CommittedToExcellenceHeading: "Committed to Excellence in Wellness",
          bookCryo: "Book Cryo-Massage",
          bookTraditional: "Book Traditional Massage",
          CommittedToExcellencePara:
            "Experience a sanctuary of complete wellness, where relaxation, Healing, and beauty come together under one roof at The Spa Wellness.",
          newsLetterText:
            "Join our community for expert tips, exclusive offers, and the latest in wellness.",

          home: "Home",
          about: "About",
          usefullLinks: "Quick Links",
          priceList: "Price List",
          services: "Services",
          specials: "Specials",
          memberships: "Memberships",
          contact: "Contact",
          artistrySpawellness: "Artistry Spa & Wellness",
          subzeroCryotherapy: "SUBZERO CRYOTHERAPY",
          elevateWellnessJourney:
            "Utilize pressurized CO2 at -110°F to deliver an extremely effective and targeted treatment. Provide numerous benefits including: pain relief, decreased inflammation, improved blood flow, and aesthetic benefits.",
          bookService: "BOOK A SERVICE",
          embraceNewBeginning:
            "Embrace a New Beginning by Cultivating a Healthier Routine",
          selfCareJourney:
            "Your self-care journey begins at Oasis Healing Massage",
          getMembershipToday: "Get Your Membership Today!",
          massage: "Massage",
          massageDescription:
            "Nurture Your Body and Soul with our Skilled and Certified Massage Therapists, Delivering Therapeutic and Serene Massage Treatments.",
          facials: "Facials",
          facialsDescription:
            "Nurture Your Body and Soul with our Skilled and Certified Massage Therapists, Delivering Therapeutic and Serene Massage Treatments.",
          reiki: "Reiki",
          reikiDescription:
            "Discover the Profound Healing of Reiki with our Skilled Practitioners. Unleash Inner Harmony and Vitality through our Reiki Services, Nurturing Your Well-Being to the Fullest.",
          rejuvenateYourSenses: "REJUVENATE YOUR SENSES",
          ourServices: "Our Services",
          servicePageHeading: "Artistry Spa & Wellness Services",
          serviceInfo:
            "Immerse Yourself in pure Tranquility with our Unparalleled Spa Sercices",
          howItWorks: "How It Works",
          getStart: "GET STARTED: REGISTER YOURSELF TODAY",
          connectWithUs: "CONNET WITH US",
          enjoyAmazingOffer: "ENJOYE OUR AMAZING OFFERS",
          tranquilityQuality: "TRANQUILITY AND RENEWAL",
          tranquilityDisc1:
            "Welcome to a sanctuary of serenity and rejuvenation – Oasis Healing Massage.",
          tranquilityDisc2:
            "Our licensed therapists are dedicated to providing you with a range of services designed to replenish your mind, body, and spirit.",
          tranquilityDisc3:
            "Experience the transformative power of our treatments and embark on a journey toward ultimate relaxation and renewal.",
          bookNow: "Book Now",
          personalizedApproachTitle: "PERSONALIZED APPROACH TO",
          personalizedApproachTitle2: "Artistry Spa & Wellness",
          wellnessContent1:
            "Our dedicated experts deeply comprehend your unique needs, guaranteeing customized services that cater specifically to you.",
          wellnessContent2:
            "Experience the art of stress reduction and embrace a more balanced lifestyle as we wholeheartedly commit to your journey towards complete well-being.",
          wellnessContent3:
            "Our holistic approach and evidence-based methods are aimed at helping you attain optimal wellness.",
          testimonials: "Testimonials",
          photoGallery: "Photo Gallery",
          // allRightSeserve: "© 2024 Artistry | All Rights Reserved",
          allRightSeserve:
            "Copyright © 2024 Artistry Spa & Wellness - All Rights Reserved.",
          PrivacyPolicy: "Privacy Policy",
          CancellationPolicy: "Cancellation Policy",
          termsConditions: "Terms and Conditions",
          whatSubzeroCryo: "What is Subzero Cryo?",
          whatSubzeroCryoDisc1:
            "We use one of the newest and most effective technologies on the market - a device Subzero Cryo",
          whatSubzeroCryoDisc2:
            "The procedure includes spraying the treatment area with dry vapour of carbon dioxide (CO2), as cold as -108° F, under pressure as high as 50 bar, in short 90-second increments. The combination of precise targeting, extremely low temperatures, and strength of the flow result in more rapid and deeper cooling of the affected tissue, producing better results faster. ",
          whatSubzeroCryoDisc3:
            "This technique is not considered a medical treatment, but rapid cooling of the skin and underlying tissue can be used for pain management, stimulation of cell regeneration, tightening and brightening of the skin, anti-aging facials, and reduction of stubborn fat deposits and cellulite.",
          whatSubzeroCryoDisc4:
            "Thermal shock improves blood flow in the treatment area and helps reduce inflammation. If applied to fat cells that are more sensitive to cold than any other cell in the body, cooling triggers a process called cryolipolysis and results in apoptosis – controlled permanent destruction of subcutaneous fat tissue.",
          whatSubzeroCryoDisc5:
            "Thermal shock improves blood flow in the treatment area and helps reduce inflammation. If applied to fat cells that are more sensitive to cold than any other cell in the body, cooling triggers a process called cryolipolysis and results in apoptosis – controlled permanent destruction of subcutaneous fat tissue.",
          whatSubzeroCryoDisc6:
            "Localised cryotherapy is safe for most people, but some contraindications have been identified and negative side effects are possible. Familiarising yourself with the below information will help you avoid unwanted consequences.",
          feedComingSoon: "Feed Coming Soon",
          priceListDisc1:
            "Therapeutic touch to relax, relieve tension, and promote well-being",
          swedishMassage: "Swedish Massage",
          priceListDisc2:
            "Gentle, flowing strokes for relaxation, tension relief, and overall well-being.",
          priceListRate2: "(60 mins $125 / 90 mins $175)",
          reflexologyMassage: "Reflexology Massage",
          priceListDisc3:
            "Pressure on specific points to promote relaxation and healing.",
          priceListRate3: "(60 mins $125 / 90 mins $175)",
          therapeuticMassage: "Therapeutic Massage",
          priceListDisc4:
            "Targeted treatment to address specific health issues and promote relaxation.",
          priceListRate4: "(60 mins $125 / 90 mins $175)",
          sportMassage: "Sport Massage",
          priceListRate5: "(60 mins $125 / 90 mins $175)",
          priceListDisc5:
            "Deep tissue massage to prevent injury and improve athletic performance",
          hotStoneMassage: "Hot Stone Massage",
          priceListDisc6:
            "heated stones used to relax muscles and promote well-being",
          priceListRate6: "(60 mins $125 / 90 mins $175)",
          priceListDisc7:
            "Simultaneous massage for two people for a bonding experience",
          priceListRate7: "(60 mins $125 / 90 mins $175)",
          sendMessage: "Send Message",
          address: "227 W Thompson St, Philadelphia, PA 19122",
          hours: "HOURS",
          appointmentsEncouraged: "- Appointments are encouraged",
          openWeek: " - We are open 7 days a week",
          name: "Name (First, Last)*",
          email: "Email",
          phone: "Phone",
          message: "Message",

          submit: "Submit Now",

          whatSubzeroCryotherapy:
            "Instant Recovery with Cryo & Massage Treatments",
          whatBenefitsTitle: "Transform Your Body & Life",
          whatBenefitsInfo:
            "Experience comprehensive wellness solutions tailored to your unique needs and goals",
          BannerTitleAbout: "Restore and Revitalize with Expert Massage",
          bannerTitleService:
            "Enhancing Beauty and Vitality Through Advanced Therapies",
          bannerTitlePriceList:
            "Comprehensive Price List for Artistry Spa & Wellness Services",
          bannerTitleContact: "Get in Touch with Artistry Spa & Wellness",
          fitnessRecovery: "Athletic & Fitness Recovery",
          fitnessRecoveryDesc:
            "Optimize your performance and recovery with cutting-edge techniques",
          painReductionDesc:
            "Advanced solutions for chronic pain and discomfort management",
          fatLossDesc:
            "Targeted treatments for sustainable body transformation",
          antiAgingDesc: "Rejuvenate your skin with advanced cryo technology",
          beforeAfter: "Real results from our satisfied clients",
          result: "Measurable improvements in body composition",
          Transformation: "Life-changing success stories",

          painReduction: "Pain Reduction Treatments",
          fatLoss: "Fat Loss and Cellulite Reduction",
          antiAging: "Cryo Facials & Anti-Aging",
          // theResult:"The result",
          visit: "Off First Time Visit",
          before: "Before",
          after: "After",
          pageNotFound: "Page Not Found",
          errorMessage: "We can't seem to find the page you're looking for",
          goHomeBtn: "GO TO HOME PAGE",
          welcomeAboutText:
            "Welcome to Artistry Spa & Wellness, where we believe in the power of holistic health",
          aboutDesc1:
            "At Artistry Spa & Wellness, our team specializes in pain management, weight management, and gut health. We understand that true wellness encompasses not just the body, but the mind and spirit as well.",
          aboutDesc2:
            "Our dedicated team is here to support you on your journey to optimal health and well-being. Whether you are struggling with skin conditions, chronic pain, looking to shed some extra pounds, or seeking to improve your digestive health, we are here to help",
          aboutDesc3:
            "Book a complimentary 10-15 minute phone call with us to learn more about how we can support you in your goals for pain management, weight management, and gut health. Our team will work with you to create a personalized plan that meets your unique needs and lifestyle.",
          aboutDesc4:
            "Contact Artistry Spa & Wellness today to schedule your complimentary consultation. We can't wait to help you on your journey to wellness.",
          transformation: "Transformation",
          bookAppointent: "Book An Appointment",
          readMore: "Read More",
          getUpdateText:
            "Get Exclusive Updates On Artistry Spa & Wellness Special Offers",
          getUpdatedPara: "Everything you need to feel healthy and beautiful",
          getSubscribe: "Subscribe",
          contactInputPlaceholder: "Enter your email",
          aboutSection: {
            heading: "Welcome to Artistry Spa & Wellness",
            introParagraph:
              "Step into a world where beauty meets tranquility. At Artistry Spa & Wellness, we believe in nurturing both your body and soul, offering a sanctuary from the hustle of everyday life.",
            benefit1: {
              text: "Personalized care tailored to your unique needs",
              icon: "FaHeart",
            },
            benefit2: {
              text: "Cutting-edge treatments for optimal results",
              icon: "BiSolidZap",
            },
            servicesParagraph:
              "From rejuvenating facials to invigorating body treatments, our expert team is dedicated to enhancing your natural beauty and promoting overall wellness.",
            buttonText: "Explore Our Services",
          },
          whyChooseUs: {
            heading: "Why Choose Us",
            intro:
              "At Artistry Spa & Wellness, we are committed to providing exceptional care and results. Here’s why you should choose us:",
            reasons: {
              expertCare: {
                title: "Expert Care",
                description:
                  "Skilled professionals, such as a professional certified cryo therapist, and Licensed massage therapist, licensed aesthetician.provide expert care in every treatment.",
              },
              personalizedApproach: {
                title: "Personalized Approach",
                description:
                  "We believe in tailoring our services to your individual needs and goals.",
              },
              stateOfTheArtTech: {
                title: "State-of-the-Art Technology",
                description:
                  "We utilize the latest advancements in beauty and wellness technology to deliver optimal results.",
              },
              warmAtmosphere: {
                title: "Warm and Welcoming Atmosphere",
                description:
                  "Our spa is designed to create a relaxing and rejuvenating environment where you can escape the stresses of daily life.",
              },
              commitmentWellness: {
                title: "Commitment to Wellness",
                description:
                  "We are passionate about helping you achieve your wellness goals and look your best.",
              },
            },
            buttonText: "Explore More",
          },
          getConsultationHeading:
            "Enjoy a Complimentary Consultation with Our Artistry Spa & Wellness Experts",
          consultationHeading:
            "Artistry Spa Wellness enhances beauty and vitality through health-focused treatments.",
          bookAppointmentBtn: "Book Your Appointment",
          footerText:
            "At Artistry Spa Wellness, we are dedicated to delivering an experience that embodies the care and rejuvenation you deserve.",
          ourAddress:
            "227 W Thompson St, Philadelphia, PA 19122, United States",
        },
      },
      cn: {
        translation: {
          timingIs: "时间是",
          getUpdateText: "获取有关Artistry Spa & Wellness特别优惠的独家更新",
          getUpdatedPara: "一切让您感到健康和美丽的资讯",
          getSubscribe: "订阅",
          contactInputPlaceholder: "输入您的电子邮件",
          localizedCryotherapy: "局部冷冻疗法",
          cryoMassage: "冷疗按摩",
          cryotherapyFacial: "冷冻面部护理",
          cryoSlimming: "冷冻瘦身",
          faceMassage: "面部按摩",
          therapyAddictionalMassage: "附加理疗按摩",
          coupleMassage: "情侣按摩",
          aboutArtistrySpawellnes: "关于我们",
          subsOurNewsletter: "立即订阅",
          contactInfo: "联系方式",
          CommittedToExcellenceHeading: "致力于卓越的健康服务",
          bookCryo: "预约冷冻按摩",
          bookTraditional: "预约传统按摩",
          CommittedToExcellencePara:
            "体验完美的健康圣地，在这里，放松、疗愈和美丽齐聚一堂，尽在The Spa Wellness。",
          newsLetterText:
            "加入我们的社区，获取专家建议、独家优惠和最新的健康信息。",

          getConsultationHeading:
            "享受与我们Artistry Spa Wellness专家的免费咨询",
          consultationHeading:
            "Artistry Spa Wellness通过健康为本的疗程提升美丽与活力",
          bookAppointmentBtn: "预约您的时间",
          footerText:
            "在Artistry Spa Wellness，我们致力于为您提供充满关怀与焕新体验的服务。",
          ourAddress: "美国宾夕法尼亚州费城汤普森街227号，邮编19122",

          whyChooseUs: {
            heading: "为什么选择我们",
            intro:
              "在Artistry Spa & Wellness，我们致力于提供卓越的护理和效果。以下是您选择我们的理由：",
            reasons: {
              expertCare: {
                title: "专家护理",
                description:
                  "专业人员，如注册护士和持证美容师，在每个治疗中提供专业护理。",
              },
              personalizedApproach: {
                title: "个性化方案",
                description:
                  "我们相信根据您的个人需求和目标量身定制我们的服务。",
              },
              stateOfTheArtTech: {
                title: "尖端科技",
                description: "我们利用最新的美容和健康技术进步来提供最佳效果。",
              },
              warmAtmosphere: {
                title: "温馨宜人的氛围",
                description:
                  "我们的水疗中心旨在营造一个放松和恢复活力的环境，让您远离日常生活的压力。",
              },
              commitmentWellness: {
                title: "对健康的承诺",
                description: "我们热衷于帮助您实现健康目标并展现最佳状态。",
              },
            },
            buttonText: "探索更多",
          },

          service: {
            type: "按摩",
            typeDesc: "通过治疗性触摸来放松、缓解紧张并促进健康。",
          },
          massages: {
            meridian60: {
              title: "经络按摩 - 60分钟",
              description:
                "经络按摩是一种源于传统中医的治疗性身体疗法，通过刺激人体被称为经络的能量通道，恢复身体平衡并促进康复。",
              cost: "$130.00",
            },
            swedish60: {
              title: "瑞典按摩 - 60分钟",
              description:
                "轻柔的流动手法，帮助放松、缓解紧张，提升整体健康感。",
              cost: "$125.00",
            },
            swedish90: {
              title: "瑞典按摩 - 90分钟",
              description:
                "轻柔的流动手法，帮助放松、缓解紧张，提升整体健康感。",
              cost: "$175.00",
            },
            // swedish120: {
            //   title: "瑞典按摩 - 120分钟",
            //   description: "使用按摩油进行平滑的流动手法，覆盖整个身体。",
            // price: "130.00美元 或4次付款，每次32.50美元"
            // },
            reflexology60: {
              title: "反射疗法按摩 - 60分钟",
              description: "通过特定穴位的压力来促进放松和康复。",
              cost: "$125.00",
            },
            reflexology90: {
              title: "反射疗法按摩 - 90分钟",
              description: "通过特定穴位的压力来促进放松和康复。",
              cost: "$175.00",
            },
            // reflexology120: {
            //   title: "反射疗法按摩 - 120分钟",
            //   description: "通过特定穴位的压力来促进放松和康复。",
            // price: "130.00美元 或4次付款，每次32.50美元"
            // },
            therapeutic60: {
              title: "治疗性按摩 - 60分钟",
              description: "针对特定健康问题的治疗，促进放松。",
              cost: "$125.00",
            },
            therapeutic90: {
              title: "治疗性按摩 - 90分钟",
              description: "针对特定健康问题的治疗，促进放松。",
              cost: "$175.00",
            },
            // therapeutic120: {
            //   title: "治疗性按摩 - 120分钟",
            //   description: "针对特定健康问题的治疗，促进放松。",
            // price: "130.00美元 或4次付款，每次32.50美元"
            // },
            sport60: {
              title: "运动按摩 - 60分钟",
              description: "深层组织按摩，预防伤害，提升运动表现。",
              cost: "$125.00",
            },
            sport90: {
              title: "运动按摩 - 90分钟",
              description: "深层组织按摩，预防伤害，提升运动表现。",
              cost: "$175.00",
            },
            // sport120: {
            //   title: "运动按摩 - 120分钟",
            //   description: "深层组织按摩，预防伤害，提升运动表现。",
            // price: "130.00美元 或4次付款，每次32.50美元"
            // },
            hotStone60: {
              title: "热石按摩 - 60分钟",
              description: "使用加热石头放松肌肉，促进健康。",
              cost: "$125.00",
            },
            hotStone90: {
              title: "热石按摩 - 90分钟",
              description: "使用加热石头放松肌肉，促进健康。",
              cost: "$175.00",
            },
            // hotStone120: {
            //   title: "热石按摩 - 120分钟",
            //   description: "使用加热石头放松肌肉，促进健康。",
            // price: "130.00美元 或4次付款，每次32.50美元"
            // },
            couple60: {
              title: "情侣按摩 - 60分钟",
              description:
                "两人同时按摩，增进亲密体验。（备注：请在同一账户下预订两次，并选择在同一时间不同的按摩师！）",
              cost: "$125.00",
            },
            couple90: {
              title: "情侣按摩 - 90分钟",
              description:
                "两人同时按摩，增进亲密体验。（备注：请在同一账户下预订两次，并选择在同一时间不同的按摩师！）",
              cost: "$175.00",
            },
            lymphaticDrainage: {
              title: "淋巴引流按摩",
              description:
                "轻柔手法刺激淋巴流动，有助于减轻肿胀、支持排毒并促进放松。",
              cost: "$165.00",
            },
          },

          ServiceHighlightCryoSlimming: {
            heading: "冷冻瘦身",
            para: "通过冷冻瘦身，使用冷疗技术分解顽固脂肪细胞，帮助您达到纤细紧致的效果。这是一种非侵入性疗法。",
            benefits: "好处：",
            benefitsLi1: "非侵入性",
            benefitsLi2: "身体塑形",
            benefitsLi3: "减少脂肪",
            idealFor: "适合人群：",
            idealForText: "顽固脂肪减少、产后妈妈、特殊场合准备",
            duration: "30-45分钟",
          },

          ServiceHighlightLocalizedCryo: {
            heading: "局部冷疗",
            para: "通过我们的局部冷疗服务，体验针对性疼痛和炎症的缓解。冷疗聚焦于特定部位，帮助减轻肿胀、缓解疼痛并加速愈合。",
            benefits: "好处：",
            benefitsLi1: "加速恢复",
            benefitsLi2: "减轻炎症",
            benefitsLi3: "缓解疼痛",
            idealFor: "适合人群：",
            idealForText: "运动员、慢性疼痛患者、术后恢复",
            duration: "10-20分钟",
          },

          CryoFacial: {
            heading: "冷冻面部护理",
            para: "通过我们的冷冻面部护理，焕发肌肤活力，使用冷疗促进胶原蛋白生成，减轻浮肿，增强自然光彩。这种非侵入性、快速的面部护理令肌肤紧致、均匀、亮丽。",
            benefits: "好处：",
            benefitsLi1: "促进胶原蛋白生成",
            benefitsLi2: "减轻浮肿",
            benefitsLi3: "改善肤色和质地",
            idealFor: "适合人群：",
            idealForText:
              "需要快速、非侵入性肌肤护理者、抗衰老、减少发红和炎症",
            duration: "10-15分钟",
          },

          Cryotherapy: {
            heading: "冷冻疗法",
            para: "体验全身冷冻疗法的焕发活力，它通过极冷环境促进更快的恢复，减轻炎症并提升能量水平。这种创新疗法有助于刺激循环、改善情绪并缓解肌肉和关节不适。",
            benefits: "好处：",
            benefitsLi1: "加速恢复",
            benefitsLi2: "减轻炎症",
            benefitsLi3: "提升能量",
            idealFor: "适合人群：",
            idealForText: "运动员、慢性疼痛患者、炎症减轻",
            duration: "2-3分钟",
          },

          TherapeuticMassage: {
            heading: "治疗按摩",
            para: "通过我们的治疗按摩缓解疼痛和压力，专为缓解酸痛肌肉、促进血液循环并支持愈合而设计。我们的专业按摩师应用针对性技术，帮助恢复平衡、提高柔韧性，并带来持久的放松效果。",
            benefits: "好处：",
            benefitsLi1: "疼痛缓解",
            benefitsLi2: "提升柔韧性",
            benefitsLi3: "促进血液循环",
            idealFor: "适合人群：",
            idealForText: "慢性疼痛、压力缓解、肌肉紧张",
            duration: "30-60分钟",
          },
          eyeleshExtension: {
            heading: "睫毛延长",
            para: "混合型睫毛延长结合了单根睫毛和轻扇型睫毛，创造出一种自然美丽的质感，提升您的眼部魅力。这种多功能的组合既增加了浓密感和层次感，又保持柔软、轻盈的外观，适合任何场合。",
            benefits: "优势:",
            benefitsLi1: "自然外观与浓密感兼具",
            benefitsLi2: "浓密度可定制",
            benefitsLi3: "增强眼部轮廓",
            idealFor: "适合人群:",
            idealForText: "寻求自然与戏剧性睫毛效果平衡的个体",
            duration: "1.5 - 2 小时",
          },

          // monthlyMembership: {
          // monthlyMembership30: {
          //   title: "月度会员：30分钟按摩",
          //   description: "更新的月度会员政策，每月最多使用8次，未使用服务无法结转。",
          //   price: "200.00美元 或4次付款，每次10.00美元"
          // },
          // monthlyMembership40: {
          //   title: "月度会员：40分钟按摩",
          //   description: "更新的月度会员政策，每月最多使用8次，未使用服务无法结转。",
          //   price: "250.00美元 或4次付款，每次12.50美元"
          // },
          // monthlyMembership60: {
          //   title: "月度会员：60分钟按摩",
          //   description: "更新的月度会员政策，每月最多使用8次，未使用服务无法结转。",
          //   price: "300.00美元 或4次付款，每次17.50美元"
          // },
          //  },
          signaturefacial: {
            refreshingFacials: {
              title: "清爽护理面部护理",
              description:
                "出色的护理，控制油脂，保持平衡，延缓早期衰老迹象。（60分钟）",
              price: "142.00美元",
              cost: "$142.00",
            },
            dimondFacials: {
              title: "钻石护理面部护理",
              description:
                "护理平衡肤色，保持年轻皮肤的光彩，延缓早期衰老迹象。（60分钟）",
              price: "95.00美元 或4次付款，每次23.75美元",
            },
            renewingFacials: {
              title: "焕新护理面部护理",
              description: "修复衰老迹象，包括细纹和皱纹。（60分钟）",
              price: "115.00美元 或4次付款，每次28.75美元",
            },
          },
          cryoSkinHealth: {
            cryoSkinHealth1: {
              title: "冷疗皮肤健康（痤疮、湿疹、牛皮癣） - 1次",
              description:
                "冷疗用于治疗皮肤病，如痤疮、湿疹和牛皮癣。无副作用减少症状。",
              price: "150.00美元 或4次付款，每次37.50美元",
            },
            cryoSkinHealth5: {
              title: "冷疗皮肤健康（痤疮、湿疹、牛皮癣） - 5次",
              description: "冷疗治疗皮肤病。五次疗程显著减少症状。",
              price: "499.00美元 或4次付款，每次124.75美元",
            },
          },
          cryoFacial: {
            cryoFacial1: {
              title: "冷疗面部护理 - 1次",
              description: "无创美容护理，通过低温改善肤色并刺激胶原蛋白生成。",
              price: "120.00美元 或4次付款，每次30.00美元",
            },
            cryoFacial5: {
              title: "冷疗面部护理 - 5次",
              description:
                "五次无创美容护理，改善肤色，刺激胶原蛋白生成，提升光泽。",
              price: "499.00美元 或4次付款，每次124.75美元",
            },
          },
          cryoslimming: {
            cryoSlimming1: {
              title: "冷疗瘦身 - 1次",
              description: "冷疗永久消灭脂肪细胞，通过紧致肌肤立即减少围度。",
              price: "259.00美元 或4次付款，每次64.75美元",
            },
            cryoSlimming3: {
              title: "冷疗瘦身 - 3次",
              description: "冷疗通过三次疗程消灭脂肪细胞，减少围度。",
              price: "799.00美元 或4次付款，每次199.75美元",
            },
            cryoSlimming5: {
              title: "冷疗瘦身 - 5次",
              description: "冷疗通过五次疗程消灭脂肪细胞，减少围度。",
              price: "1299.00美元 或4次付款，每次324.75美元",
            },
            cryoSlimming8: {
              title: "冷冻瘦身 - 8次疗程",
              description: "冷冻疗法通过八次疗程摧毁脂肪细胞并实现减脂效果。",
              price: "$1799.00",
              cost: "$130.00",
            },
            cryoSlimming10: {
              title: "冷疗瘦身 - 10次",
              description: "通过十次冷疗消灭脂肪细胞，显著减少围度。",
              price: "2499.00美元",
            },
          },
          targetedCryotherapy: {
            cryoSlimming5: {
              title: "对于小面积来说。",
              description:
                "非侵入性冷疗法可触发身体的自然战斗反应，加速恢复并减少全身炎症。此疗程针对的是需要立即关注的特定区域！",
              price: "$80.00",
              cost: "$80.00",
            },
            cryoSlimming8: {
              title: "针对整个上背部或下背部的区域。",
              description:
                "与全身冷冻舱不同，我们能够针对需要治疗的特定部位进行冷冻。这对运动员、我们的服务人员、急救人员、教师以及许多长时间坐在工作岗位上的人来说都非常有效，这些人往往会因此患上“梨状肌综合征”，即臀部肌肉，坐骨神经穿过这一部位，导致背部和神经疼痛。",
              price: "120.00 美元或 4 次付款，每次 30.00 美元",
              cost: "$120.00",
            },
            cryoSlimming10: {
              title: "目標區域包 的 5",
              description:
                "與全身冷凍室不同，我們能夠針對要治療的特定區域。這對運動員、我們引以為傲的服役人員、急救人員、教師以及許多在工作場所長時間坐著的人來說是一件轟動的事情，這些人常常會導致“梨狀肌綜合症”，這是臀部的肌肉，坐骨神經痛神經貫穿，造成許多背部和神經疼痛.",
              price: "$499.00 或 4 次付款，每次 $124.75",
              cost: "$499.00",
            },
          },

          eyelashesExtension: {
            eyelashService1: {
              title: "混合型",
              description:
                "混合睫毛将单根睫毛和轻扇完美融合，打造美丽自然的纹理，增强您的双眼。这款多功能套装提供丰满感和尺寸感，同时在任何场合都能保持柔软、轻松的外观",
              cost: "$120",
            },
            eyelashService2: {
              title: "局部",
              description:
                "通过将由 6 至 12 根睫毛延长线组成的扇形涂抹到每根睫毛上，丰盈睫毛可增强您的自然睫毛，打造引人注目、更丰盈的外观。这项服务可增加睫毛的体积和长度，显着改变您的睫毛，使其看起来更迷人。",
              cost: "$150",
            },
            eyelashService3: {
              title: "全局",
              description:
                "由艺术大师熟练涂抹的 Mega Volume 可增强您的自然睫毛，使其具有无与伦比的丰盈度和长度。该服务在每根健康的睫毛上使用 5 至 15 个超细睫毛延长器，为您的外观带来非凡的厚度、蓬松度和引人注目的长度。",
              cost: "$190",
            },
          },

          cryoSlimmingService: {
            heading: "冷冻瘦身",
            desc: "冷冻瘦身是一种非侵入性治疗，通过低温冻结脂肪细胞，逐步排除顽固脂肪。适用于腹部、大腿和侧腰等部位的塑形，帮助您在无手术和无恢复期的情况下，获得更纤细、紧致的身形。",
          },
          cryoMassageService: {
            heading: "冷疗按摩",
            desc: "冷疗按摩结合了传统按摩与冷疗，通过可控的冷却减少炎症、缓解肌肉酸痛并加速恢复。该疗法促进血液循环，缓解紧张，加快愈合，非常适合运动员和需要肌肉放松的人士。",
          },
          cryoFacialService: {
            heading: "冷疗面部护理",
            desc: "冷疗面部护理是一种皮肤焕活疗法，通过冷疗收紧、消肿和提亮面部肌肤。它可缩小毛孔，提升胶原蛋白，平滑细纹，改善肤色，使您的肌肤紧致光泽，无需恢复期。",
          },
          targetedCryoService: {
            heading: "局部冷疗",
            desc: "局部冷疗使用极寒温度来缓解特定身体部位的疼痛、炎症和不适，适用于受伤、肌肉酸痛和关节疼痛。该局部疗法加速恢复，改善循环，并提供无创的快速缓解。",
          },
          cryoSkinHealthService: {
            heading: "冷疗皮肤健康（痤疮、湿疹、牛皮癣）",
            desc: "冷疗皮肤健康通过冷疗来治疗痤疮、湿疹和牛皮癣等皮肤问题，镇静和修复受刺激的皮肤。它减少炎症，缓解发红，支持自然愈合，为您带来更清晰、更健康的皮肤，无需使用刺激性化学品或侵入性手段。",
          },
          eyeleshService: {
            heading: "睫毛延长",
            desc: "混合型睫毛延长结合了单根睫毛和轻扇型睫毛，创造出一种自然美丽的质感，提升您的眼部魅力。这种多功能的组合既增加了浓密感和层次感，又保持柔软、轻盈的外观，适合任何场合。",
          },
          coupleMassageService: {
            heading: "情侣按摩",
            desc: "与您的伴侣一起享受我们的情侣按摩体验，使用同步技术缓解压力，增进亲密关系。无论何种场合，这项体验都会让您们都感到放松与亲密。",
          },

          home: "家",
          about: "关于",
          priceList: "价位表",
          services: "服务",
          specials: "特别优惠",
          memberships: "会员",
          contact: "来往",
          artistrySpawellness: "艺术水疗与健康",
          elevateWellnessJourney: "通过我们卓越的按摩服务提升您的健康之旅",
          subzeroCryotherapy: "零度以下冷冻疗法",
          bookService: "预定服务",
          embraceNewBeginning: "通过培养更健康的习惯迎接新的开始",
          selfCareJourney: "您的自我护理旅程从绿洲康复按摩开始",
          getMembershipToday: "今天就獲得會員資格！",
          massage: "按摩",
          massageDescription:
            "通过我们熟练和认证的按摩治疗师，培养您的身心灵，提供治疗性和宁静的按摩疗法。",
          facials: "面部护理",
          facialsDescription:
            "通过我们熟练和认证的按摩治疗师，培养您的身心灵，提供治疗性和宁静的按摩疗法。",
          reiki: "灵气疗法",
          reikiDescription:
            "与我们熟练的灵气疗法师一同探索深层治愈的灵气。通过我们的灵气服务释放内在和谐与活力，充分培养您的健康福祉。",
          rejuvenateYourSenses: "恢復您的感官活力",
          ourServices: "我们的服务",
          serviceInfo: "享受我们无与伦比的水疗服务，让自己沉浸在纯粹的宁静之中",
          howItWorks: "怎么运行的",
          getStart: "立即开始：立即注册",
          connectWithUs: "联系我们",
          enjoyAmazingOffer: "享受我们的精彩优惠",
          tranquilityQuality: "寧靜與更新",
          tranquilityDisc1: "歡迎來到寧靜和恢復活力的聖地—綠洲療癒按摩。",
          tranquilityDisc2:
            "我們的執照治療師致力於為您提供一系列服務，旨在補充您的思想、身體和精神。",
          tranquilityDisc3:
            "體驗我們護理的改變力量，踏上終極放鬆和煥然一新的旅程。",
          bookNow: "現在預訂",
          personalizedApproachTitle: "個人化方法",
          personalizedApproachTitle2: "艺术家水疗和健康中心",
          wellnessContent1:
            "我們的專業專家深入了解您的獨特需求，保證為您提供專門的客製化服務。",
          wellnessContent2:
            "體驗減壓的藝術，擁抱更平衡的生活方式，我們全心全意地致力於您的幸福之旅。",
          wellnessContent3:
            "我們的整體方法和基於證據的方法旨在幫助您獲得最佳健康。",
          testimonials: "评价",
          photoGallery: "图片库",
          // allRightSeserve: "© 2024 Artistry | 保留所有权利",
          allRightSeserve:
            "版权所有 © 2023 Artistry Spa & Wellness - 保留所有权利。",
          PrivacyPolicy: "隐私政策",
          CancellationPolicy: "取消政策",
          termsConditions: "条款和条件",
          whatSubzeroCryo: "什么是零下冷冻按摩？",
          whatSubzeroCryoDisc1:
            "我们采用市场上最新、最有效的技术之一——Subzero Cryo 设备",
          whatSubzeroCryoDisc2:
            "该程序包括以 50 巴的压力，在 90 秒的短时间内向治疗区域喷洒二氧化碳 (CO2) 干蒸汽，温度低至 -108° F。精准定位、极低温度和流量强度相结合，可更快、更深层地冷却受影响的组织，从而更快地产生更好的效果。",
          whatSubzeroCryoDisc3:
            "该技术不被视为医疗手段，但可以通过快速冷却皮肤和下层组织来控制疼痛、刺激细胞再生、收紧和提亮皮肤、抗衰老面部护理以及减少顽固脂肪沉积和脂肪团。",
          whatSubzeroCryoDisc4:
            "热冲击可改善治疗区域的血流，有助于减少炎症。如果将冷却应用于对寒冷比身体任何其他细胞都更敏感的脂肪细胞，冷却会触发一种称为冷冻脂肪分解的过程，并导致细胞凋亡——控制皮下脂肪组织的永久性破坏。",
          whatSubzeroCryoDisc5:
            "热冲击可改善治疗区域的血流，有助于减少炎症。如果将冷却应用于对寒冷比身体任何其他细胞都更敏感的脂肪细胞，冷却会触发一种称为冷冻脂肪分解的过程，并导致细胞凋亡——控制皮下脂肪组织的永久性破坏。",
          whatSubzeroCryoDisc6:
            "局部冷冻疗法对大多数人来说是安全的，但已发现一些禁忌症，并且可能产生负面副作用。熟悉以下信息将有助于您避免不必要的后果。",
          feedComingSoon: "饲料即将推出",
          priceListDisc1: "治疗性触摸可放松、缓解紧张并促进健康",
          swedishMassage: "瑞典式按摩",
          priceListDisc2:
            "轻柔、流畅的抚摸有助于放松、缓解紧张并促进整体健康。",
          priceListRate2: "(60 分钟 125 美元 / 90 分钟 175 美元)",
          reflexologyMassage: "足底按摩",
          priceListDisc3: "对特定穴位施压以促进放松和愈合。",
          priceListRate3: "（60 分钟 125 美元/90 分钟 175 美元）",
          therapeuticMassage: "治疗按摩",
          priceListDisc4: "针对特定的健康问题并促进放松的针对性治疗。",
          priceListRate4: "（60 分钟 125 美元/90 分钟 175 美元）",
          sportMassage: "运动按摩",
          priceListDisc5: "深层组织按摩可预防伤害并提高运动表现",
          priceListRate5: "（60 分钟 125 美元/90 分钟 175 美元）",
          hotStoneMassage: "热石按摩",
          priceListDisc6: "加热的石头用于放松肌肉和促进健康",
          priceListRate6: "（60 分钟 125 美元/90 分钟 175 美元）",
          priceListDisc7: "双人同时按摩，增进感情",
          priceListRate7: "（60 分钟 125 美元/90 分钟 175 美元）",
          sendMessage: "发信息",
          address: "227 W 汤普森街，费城，宾夕法尼亚州 19122",
          hours: "小时数",
          appointmentsEncouraged: "我们鼓励预约。",
          openWeek: "我们每周 7 天营业。",
          name: "姓名（名字，姓氏）*",
          email: "电子邮件",
          phone: "电话",
          message: "信息",
          submit: "现在提交",

          whatSubzeroCryotherapy: "通过冷冻和按摩疗法实现即时恢复",
          whatBenefitsTitle: "改变你的身体与生活",
          whatBenefitsInfo:
            "体验量身定制的全面健康解决方案，以满足您的独特需求和目标",
          BannerTitleAbout: "通过专业按摩恢复和焕发活力",
          bannerTitleService: "通过先进疗法提升美丽与活力",
          bannerTitlePriceList: "艺术水疗与健康服务的综合价格清单",
          bannerTitleContact: "与艺术水疗与健康取得联系",
          fitnessRecovery: "运动与健身恢复",
          fitnessRecoveryDesc: "通过尖端技术优化您的表现与恢复",
          painReductionDesc: "慢性疼痛和不适管理的先进解决方案",
          fatLossDesc: "针对可持续身体转变的定制疗法",
          antiAgingDesc: "通过先进的冷冻技术焕活您的肌肤",
          beforeAfter: "来自我们满意客户的真实成果",
          result: "身体成分的可测量改善",
          Transformation: "改变生活的成功故事",

          painReduction: "减轻疼痛的治疗",
          fatLoss: "减脂和减少橘皮组织",
          antiAging: "冷冻面部护理和抗衰老",
          // theResult:"结果",
          visit: "第一次访问",
          before: "以前",
          after: "以后",
          pageNotFound: "找不到网页",
          errorMessage: "我们似乎无法找到您要查找的页面",
          goHomeBtn: "去首页",
          welcomeAboutText:
            "欢迎来到 Artistry Spa & Wellness，我们相信整体健康的力量",
          aboutDesc1:
            "在 Artistry Spa & Wellness，我们的团队专注于疼痛管理、体重管理和肠道健康。我们明白，真正的健康不仅包括身体，还包括思想和精神。",
          aboutDesc2:
            "预约 10-15 分钟免费电话咨询，详细了解我们如何帮助您实现疼痛管理、体重管理和肠道健康目标。我们的团队将与您合作，制定满足您独特需求和生活方式的个性化计划。",
          aboutDesc4:
            "立即联系 Artistry Spa & Wellness 安排免费咨询。我们迫不及待地想帮助您踏上健康之旅。",
          transformation: "转型",
          type: "按摩",
          typeDesc: "通过治疗性触摸来放松、缓解紧张并促进健康。",
          serviceCryoMassage: "冷冻按摩",
          serviceCryoMassageType: "应用冷疗法来减轻疼痛和炎症。",
          serviceMonthlyMembership: "月度会员资格",
          serviceMonthlymembershipType:
            "按摩和健康服务每月专享折扣。非常适合定期自我护理。",
          serviceSignaturefacial: "特色面部护理服务",
          serviceSignatureFacialType:
            "奢华的面部护理旨在清洁、去除角质并恢复肌肤活力。",
          servicecryoSkinHealth: "冷冻皮肤健康（痤疮、湿疹、牛皮癣）",
          serviceCryoSkinHealthType:
            "冷冻疗法可以减轻炎症并促进痤疮、湿疹和牛皮癣的愈合。",
          serviceCryofacial:
            "冷冻疗法可以减轻炎症并促进痤疮、湿疹和牛皮癣的愈合。",
          serviceCryofacialType: "针对皱纹、细纹、瑕疵和疤痕",
          serviceCryoslimming: "冷冻瘦身",
          serviceCryoslimmingType: "永久性地破坏底层脂肪细胞（细胞凋亡）",
          serviceTargetedTherapy: "靶向冷冻治疗",
          serviceTargetedTherapyType:
            "针对特定区域，非常适合运动员、健身爱好者",
          serviceEyelashesExtension: "眼睫毛延长",
          serviceEyelashesExtensionType: "针对睫毛延长服务",
          bookAppointent: "预约预约",
          readMore: "阅读更多",
          aboutSection: {
            heading: "欢迎来到Artistry Spa & Wellness",
            introParagraph:
              "踏入一个美丽与宁静相遇的世界。在Artistry Spa & Wellness，我们致力于呵护您的身心，为您提供一个远离日常生活喧嚣的静谧之地。",
            benefit1: {
              text: "量身定制的个性化护理，满足您的独特需求",
              icon: "FaHeart",
            },
            benefit2: {
              text: "尖端治疗，带来最佳效果",
              icon: "BiSolidZap",
            },
            servicesParagraph:
              "从焕发活力的面部护理到振奋人心的身体护理，我们的专业团队致力于提升您的自然美丽，促进整体健康。",
            buttonText: "探索我们的服务",
          },
        },
      },
    },
  });

export default i18n;
